import { get } from 'lodash';
import { withMeta } from '@/helpers/dataLayer';
import { mapActions } from 'vuex';
import loaderMixin from '@/mixins/loader';
import accountVerifyMixin from '@/mixins/accountVerify';
import promoCodeMixin from '@/mixins/promoCode';
import depositWarningMixin from '@/mixins/depositWarningMixin';
import depositDisclaimer from '@/components/wallet/shared/deposit-disclaimer/deposit-disclaimer.vue';
import feeWaivedBanner from '@/components/wallet/shared/fee-waived-banner/fee-waived-banner.vue';
import { DEPOSIT_METHOD_TYPE } from '@/components/wallet/shared/depositMethodTypes';

export default {
  mixins: [
    accountVerifyMixin,
    loaderMixin,
    promoCodeMixin,
    depositWarningMixin,
  ],
  components: {
    depositDisclaimer,
    feeWaivedBanner,
  },
  data() {
    return {
      depositMethodType: DEPOSIT_METHOD_TYPE.CASH,
      buttonDisabled: false,
      url: null,
      error: null,
    };
  },
  mounted() {
    this.loaderAdd();
    this.getDepositMethods();
    this.getPayNearMe('')
      .then((data) => {
        this.loaderRemove();
        this.url = data.url;
        this.promoCodeDetail = data.promoCodeDetail || {};
      })
      .catch((error) => {
        this.loaderRemove();
        this.error = get(error, 'response.data.message', 'Your authorization to deposit by cash has been disabled.');
      });
  },
  methods: {
    ...mapActions('wallet', ['getPayNearMe', 'getDepositMethods']),
    onDeposit() {
      this.$gtm.trackEvent(withMeta({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Cash Deposit',
      }));
      this.buttonDisabled = true;
      window.location.href = this.url;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/add-funds-cash/add-funds-cash.js